import api from "./instance";

export const submitSupportTicket = (formData) =>
  api.post("/staff/support-ticket", formData);

export const saveFcmToken = (payload) =>
  api.post("/staff/save-fcm-token", { fcmToken: payload.fcmToken });
